// Chakra imports
import { Flex, Heading, Image, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "common/components/separator/Separator";
import { constant } from "common/constant";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export function SidebarBrand(props) {
  const { setOpenSidebar, openSidebar, from, largeLogo } = props;

  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex
      align="center"
      className="hidden-sidebar"
      direction="column"
      style={{
        position: "sticky",
        top: "0",
        left: "0",
        paddingLeft: "26px",
      }}
    >
      <Flex>
        {/* {largeLogo && (largeLogo[0]?.logoLgImg || largeLogo[0]?.logoSmImg) ? (
          <Image
            style={{ width: "100%", height: "52px" }}
            src={
              openSidebar === true
                ? largeLogo[0]?.logoLgImg
                : largeLogo[0]?.logoSmImg
            } // Set the source path of your image
            alt="Logo" // Set the alt text for accessibility
            cursor="pointer"
            onClick={() => !from && setOpenSidebar(!openSidebar)}
            userSelect="none"
            my={2}
          />
        ) : (
          <Heading
            my={4}
            className="sidebar-logo"
            cursor={"pointer"}
            onClick={() => !from && setOpenSidebar(!openSidebar)}
            userSelect={"none"}
          >
            {openSidebar === true ? constant.name : "M"}
          </Heading>
        )} */}
      </Flex>
    </Flex>
  );
}

export default SidebarBrand;
